<template>
  <div id="user-index">
    <!-- 学生端首页 -->
    <div class="top">
      <div class="left">
        <img src="@/assets/img/logo.png" alt="" object-fit="scale-down" />
      </div>
      <div class="perch-active"></div>
      <div class="menus">
        <div
          :class="{ menu: true, 'active-menu': active == menu.path }"
          v-for="(menu, index) in menu"
          :key="index"
          @click="goto(menu)"
        >
          {{ menu.text }}
          <div class="li"></div>
        </div>
      </div>
      <div class="icon">
        <el-dropdown>
          <div class="tx">
            <img :src="userData.icon" alt="" sizes="" srcset="" />
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              ><span @click="gotoSetting(0)">密码修改</span></el-dropdown-item
            >
            <el-dropdown-item
              ><span @click="gotoSetting(1)">退出</span></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- <div class="tip"> -->
    <div class="tip" v-if="userData.defPsw">
      <!-- 初次登陆系统,需修改密码 -->
      <div class="text">
        您的密码为初始密码,安全系数较低,请尽快修改密码!!!
        <div class="link" @click="gotoSetting(0)">修改密码</div>
      </div>
    </div>
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import * as base from "./js/base.js";
export default {
  data() {
    return {
      menu: base.getMenuList(),
      active: "index",
      userData: {},
    };
  },
  methods: {
    /**
     * 路由跳转
     */
    goto(menu) {
      sessionStorage.removeItem("subMenu");
      this.active = menu.path;
      sessionStorage.setItem("fatherMenu", this.active);
      if (menu.path != "index") {
        let subMenu = base.getSubMenuListByFatherMenu(menu.path)[0].path;
        sessionStorage.setItem("subMenu", subMenu);
      }
      this.$router.push("/" + menu.path);
    },
    /**
     * 头像中的点击事件
     */
    async gotoSetting(flag) {
      switch (flag) {
        case 0:
          // 跳转值个人中心
          this.$router.push("/personal-index");
          break;
        case 1:
          // 退出
          try {
            sessionStorage.clear();
            this.$router.push("/");
          } catch (error) {
            this.$message.error(error.message);
          }
          break;

        default:
          break;
      }
    },
  },
  mounted() {
    this.active = sessionStorage.getItem("fatherMenu");
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
  },
};
</script>

<style lang="less" scoped>
#user-index {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 1000px;
  > .top {
    width: 100%;
    height: 90px;
    background-color: @baseColor;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    > .left {
      width: 280px;
      height: 100%;
      display: flex;
      // background-color: rgba(255, 255, 255, 0.363);
      align-items: center;
      justify-content: center;
      color: #fff;
      font-size: 20px;
      font-weight: bold;
      img {
        width: 100%;
      }
    }
    > .menus {
      width: auto;
      height: 100%;
      display: flex;
      margin-right: 20px;
      > .menu {
        width: auto;
        height: 100%;
        padding: 0 30px;
        display: flex;
        align-items: flex-end;
        color: #fff;
        padding-bottom: 15px;
        box-sizing: border-box;
        font-size: 14px;
        cursor: pointer;
        transition: 0.3s;
        font-weight: bold;
        &:hover {
          background-color: #fff;
          color: @baseColor;
        }
      }
      > .active-menu {
        background-color: #fff;
        color: @baseColor;
        position: relative;
        > .li {
          width: 60%;
          height: 3px;
          background-color: @baseColor;
          position: absolute;
          bottom: 5px;
          left: 20%;
        }
      }
    }
    > .icon {
      width: 90px;
      height: 90px;
      display: flex;
      align-items: center;
      justify-content: center;
      .tx {
        width: 65px;
        height: 65px;
        // background-color: #fff;
        > img {
          width: 100%;
          height: 100%;
          border-radius: 35px;
        }
      }
    }
  }
  > .tip {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: red;
    > .text {
      display: flex;
      align-items: center;
      justify-content: center;
      > i {
        margin-right: 5px;
      }
      > .link {
        margin-left: 10px;
        color: #4398fa;
        text-decoration: underline;
        padding: 0 10px;
        box-sizing: border-box;
        text-underline-offset: 5px;
        cursor: pointer;
      }
    }
  }
  > .content {
    width: 100%;
    height: 0;
    flex: 1;
    background-color: #ececec;
  }
}
</style>